import React from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
} from 'react-simple-maps';

const geoUrl = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

const TestMap: React.FC = () => {
  // Hardcoded countries for testing
  const testCountries = new Set(['ES', 'FR', 'DE', 'IT', 'GB']);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">Test Map - Simple Version</h1>
        <p className="mt-2 text-sm text-gray-700">
          Testing if colors work at all. ES, FR, DE, IT, GB should be blue.
        </p>
      </div>

      <div className="bg-white shadow rounded-lg p-6" style={{ minHeight: '500px' }}>
        <div className="text-center py-20">
          <p className="text-gray-500 mb-4">Testing if map loads...</p>
          <div style={{ width: '100%', height: '400px', border: '1px solid #e5e7eb' }}>
            <ComposableMap
              projection="geoNaturalEarth1"
            >
              <Geographies geography={geoUrl}>
                {({ geographies }: { geographies: any[] }) => {
                  console.log('Geographies loaded:', geographies.length);
                  return geographies.map((geo: any) => {
                    const iso = geo.properties.ISO_A2;
                    const isTest = testCountries.has(iso);
                    
                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        style={{
                          default: {
                            fill: isTest ? '#3B82F6' : '#E5E7EB',
                            outline: 'none',
                          },
                          hover: {
                            fill: isTest ? '#2563EB' : '#D1D5DB',
                            outline: 'none',
                          },
                          pressed: {
                            fill: '#1E40AF',
                            outline: 'none',
                          },
                        }}
                      />
                    );
                  });
                }}
              </Geographies>
            </ComposableMap>
          </div>
        </div>
      </div>

      <div className="bg-yellow-50 p-4 rounded">
        <p className="text-sm">If Spain, France, Germany, Italy, and UK are NOT blue, then there's an issue with react-simple-maps rendering.</p>
      </div>
    </div>
  );
};

export default TestMap;